import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";

const CostsBanner = () => {
	const classes = useStyles("Costs");

	return <div>xxx</div>;
};

CostsBanner.propTypes = {};
export default CostsBanner;
